const AUTH_ACTIONS = [
  'auth:assumeActiveInstitution',
  'auth:listUsers',
  'auth:listRoles',
  'auth:addUser',
  'auth:setUserRoles',
  'auth:removeUser',
];

const AUTH_ALL_ACTIONS = [
  ...AUTH_ACTIONS,
  'auth:showOrgProducts',
  'auth:removeOrgProduct',
  'auth:addOrgProduct',
  'auth:findUser',
  'auth:listProducts',
  'auth:viewUser',
];

module.exports = {
  AUTH_ACTIONS,
  AUTH_ALL_ACTIONS,
};
